module.exports = __webpack_public_path__ + "img/phase3.8654af86.png";